// sm-atc.js
// Intercepts any link whose href contains /cart/add (e.g. the standard Shopify
// cart permalink format: /cart/add?id=VARIANT_ID&quantity=1) and adds the item
// via AJAX instead of navigating, then opens the cart drawer using the theme's
// own native cart-refresh mechanism (Broadcast 8.1.1).
//
// Works with any variant/quantity combo -- no hardcoded product.

(function () {
  function addToCartAjax(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) {
          err.__isShopifyApiError = true;
          throw err;
        });
      }
      return r.json();
    });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (err) {
      return;
    }

    if (!url.pathname.replace(/\/$/, '').endsWith('/cart/add')) return;

    var variantId = url.searchParams.get('id');
    var quantity = url.searchParams.get('quantity') || '1';
    if (!variantId) return;

    e.preventDefault();

    link.style.pointerEvents = 'none';
    link.style.opacity = '0.7';

    addToCartAjax(variantId, quantity)
      .then(function () {
        // Broadcast 8.1.1: this refetches the cart, rebuilds the drawer's line
        // items, and (once the rebuild finishes) automatically dispatches
        // 'theme:product:added', which the cart-drawer element listens for
        // to open itself. No manual open call needed.
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('[sm-atc] Add to cart failed:', err);

        if (err && err.__isShopifyApiError) {
          // A real Shopify validation error (sold out, quantity limit, etc.)
          // Show the customer what's already in their cart instead of
          // yanking them to a different page.
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
          }
          if (err.description || err.message) {
            alert(err.description || err.message);
          }
        } else {
          // Genuine network failure -- fall back to native browser navigation
          // so the customer still lands somewhere useful.
          window.location.href = href;
        }
      })
      .finally(function () {
        link.style.pointerEvents = '';
        link.style.opacity = '';
      });
  });
})();
